import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'

import { selectCallTimelineFilters } from 'store/selectors'
import {
  clearCallTimelineDetailFilters,
  setCallTimelineDetailFilters,
} from 'store/actions/conferenceCall'
import usePageModal from 'features/Modal/hooks/usePageModal'
import { Link } from 'features/i18n/router'
import { snowplowEvent } from 'lib/analytics'
import { MODAL_MODE } from '../config'

import { SettingItem, Switch } from 'components'

import './style.scss'

const SelectCallSettingsModal = ({ location, modalMode, ...params }) => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const filters = useSelector(selectCallTimelineFilters)

  const { generatePageModalUrl } = usePageModal()

  const getProps = (name: string) => ({
    name,
    checked: filters.detail[name],
    onChange: (c) => {
      dispatch(setCallTimelineDetailFilters(name, c))
    },
  })

  return (
    <div className="Modal__wrapper Modal__wrapper--auto-h  SelectCallSettingsModal">
      <div className="Modal__header">
        <Link
          className="Modal__header__close Modal__header__close--back"
          to={generatePageModalUrl(MODAL_MODE.CALL_LIST_MODAL, params)}
          onClick={() => snowplowEvent.open_call_list()}
        />

        <h2 className="Modal__header__h2">
          {t('call_search_screen.detail_settings.title')}
        </h2>
      </div>

      <div className="Modal__body">
        <SettingItem
          label={t('call_search_screen.detail_settings.include_group_call')}
          noBorder
        >
          <Switch {...getProps('includeGroupCall')} />
        </SettingItem>

        <SettingItem
          label={t('call_search_screen.detail_settings.include_video_call')}
          noBorder
        >
          <Switch {...getProps('includeVideoCall')} />
        </SettingItem>

        <SettingItem
          label={t('call_search_screen.detail_settings.same_age')}
          noBorder
        >
          <Switch {...getProps('similarAge')} />
        </SettingItem>

        <SettingItem
          label={t(
            'call_search_screen.detail_settings.exclude_recently_gomimushi'
          )}
          noBorder
        >
          <Switch {...getProps('excludeGomimushi')} />
        </SettingItem>
      </div>

      <div className="Modal__footer">
        <p
          className="SelectCallSettingsModal__clear"
          onClick={() => dispatch(clearCallTimelineDetailFilters())}
        >
          {t('call_search_screen.detail_settings.clear')}
        </p>
      </div>
    </div>
  )
}

export default SelectCallSettingsModal
